import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/Header.css";
// eslint-disable-next-line no-unused-vars
import { Modal } from "bootstrap";
// Não excluir a linha acima ou a modal não aparece!
const MenuPortalItem = (props) => {
  return (
    <div className={`ContainerPortal ${props.hideOnMobile ? "hd hd-sm sw-md sw-l sw-xl sw-xxl" : ""}`}>
      <a className="nav-link padding-zero" href={`${props.href}`} target="_blank" rel="noreferrer">
        <div className={props.reverseColors ? "linkRoundedSquare-reverseColors" : "linkRoundedSquare"}
        // style={{ borderRadius: "0" }}
        // style={{
        //   borderRadius: "50%",
        //   marginTop: props.showFixed ? "12px" : "0",
        //   // padding: "0",

        // }}
        >
          <div className="centerElements" data-bs-dismiss="modal">
            <div>
              <img className="imgPortal" src={props.src} alt={props.caption} />
            </div>
            <div className="caption">{props.caption}</div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default MenuPortalItem;
